<template>
  <header class="header header--5">
    <div class="container">
      <div class="navbar d-none d-lg-flex">
        <navbar-logo></navbar-logo>
        <main-nav></main-nav>
        <div class="side-menu">
          <login-btn></login-btn>
        </div>
      </div>
      <div class="navbar navbar-mobile d-lg-none">
        <navbar-logo></navbar-logo>
        <div
          class="navbar__toggle"
          @click="toggleMenu"
        >
          <svg
            width="24"
            height="24"
          >
            <use :href="`/static/images/sprite/sprite.svg#menu${isMenuOpen ? '-close' : ''}`"></use>
          </svg>
        </div>
        <div
          class="menu-box"
          :class="{ open: isMenuOpen }"
        >
          <main-nav></main-nav>
          <login-btn></login-btn>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import NavbarLogo from "./parts/NavbarLogo.vue";
  import LoginBtn from "./parts/LoginBtn.vue";
  import MainNav from "./parts/MainNav.vue";

  export default {
    components: {
      NavbarLogo,
      LoginBtn,
      MainNav,
    },
    data() {
      return {
        isMenuOpen: false,
      };
    },
    methods: {
      toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
      },
    },
  };
</script>

<style lang="scss">
  .header--5 {
    &.header {
      padding: 8px 0;
      background: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(15px);
      z-index: 1;
      .navbar {
        padding: 0;
        .menu {
          display: flex;
          gap: 40px;
          li {
            .menu__item {
              @include font(16, 400);
              text-transform: uppercase;
              position: relative;
              transition: $transition;
              padding: 4px 24px 4px 24px;
              &.active {
                border: 1px solid $accent-color;
                border-radius: 4px;
              }
            }
          }
        }
        .side-menu {
          display: flex;
          align-items: center;
          gap: 20px;
          li {
            .menu__item {
              @include font(18, 400);
              position: relative;
              transition: $transition;
            }
          }
        }
      }
      @media (max-width: $breakpoint-lg) {
        .navbar {
          &__logo {
            width: 32px;
          }
          .menu-box {
            width: 100%;
            position: absolute;
            background-color: $white;
            padding: 16px 16px 24px 16px;
            top: 40px;
            z-index: 9;
            display: none;
            &.open {
              display: block;
            }
          }
          .menu {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 24px;
            padding: 0;
            margin-bottom: 24px;
            li {
              padding: 6px;
              .menu__item {
                @include font(16, 22);
                position: relative;
                text-transform: uppercase;
                transition: $transition;
                &.current {
                  &:before {
                    content: none;
                  }
                }
              }
            }
          }
          .login-btn {
            text-align: center;
          }
        }
      }
    }
  }
</style>
